<template>
    <div>
        <b-row>
            <b-col sm="8">
                <h5 class="heading-1 mb-4">
                    <span>Ação</span>
                </h5>
            </b-col>
            <b-col sm="4">
                <b-button class="float-right" variant="warning" @click="voltarAcao()">
                    <i class="fa fa-history"></i>
                    Voltar as ações
                </b-button>
            </b-col>
        </b-row>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-alert show>
            <b-row>
                <b-col>
                    Nome da ação:
                    <strong>
                        {{ acao.nomeAcao }}
                    </strong>
                    <br />
                    Gestor de Execução:
                    <strong>
                        {{ acao.nomeGestor }}
                    </strong>
                    <br />
                    Unidade:
                    <strong>
                        {{ acao.nomeUnidade }}
                    </strong>
                    <br />
                    Situação:
                    <app-status :status="acao.situacao">
                    </app-status>
                </b-col>
            </b-row>
        </b-alert>
        <b-card no-body>
            <b-card-header>
                <b-row>
                    <b-col>
                        <span class="h5"> Metas </span>
                    </b-col>
                    <b-col>
                        <btn-inserir-evento class="float-right"
                            v-if="acao.codSituacao != 1 && permiteInserirAtualizarEventos" :tipo="operacao" :acao="acao"
                            :dataServicos="dataServicos" @inserirEvento="inserirEvento($event)"
                            @atualizarErros="atualizarErros($event)" @atualizarListaEventos="atualizarEventos()"
                            @atualizarListaConsultorias="atualizarConsultorias()"
                            @atualizarListaEntregas="atualizarEntregas()"></btn-inserir-evento>
                    </b-col>
                </b-row>

            </b-card-header>
            <b-card-body>
                <div>
                    <b-row>
                        <b-col>
                            <h5 class="heading-1 mb-4">
                                <span>Eventos</span>
                            </h5>
                        </b-col>

                    </b-row>
                    <eventos-tabela :eventos="eventos" :operacao="operacao" :acao="acao" :dataServicos="dataServicos"
                        :permiteInserirAtualizarEventos="permiteInserirAtualizarEventos"
                        :permiteCancelarEventos="permiteCancelarEventos"
                        :temAcessoDocumentosEvento="temAcessoDocumentosEvento" :temAcessoMetas="temAcessoMetas"
                        :permiteInserirMetas="permiteInserirMetas" :permiteCancelarMetas="permiteCancelarMetas"
                        :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
                        @atualizarEvento="atualizarEvento($event)" @atualizarErros="atualizarErros($event)"
                        @cancelarEvento="cancelarEvento($event)">
                        <template slot="botoes"> </template>
                    </eventos-tabela>

                    <div v-if="temAcessoConsultoria">
                        <b-row>
                            <b-col>
                                <h5 class="heading-1 mb-4">
                                    <span>Consultorias</span>
                                </h5>
                            </b-col>

                        </b-row>
                        <consultorias-tabela :consultorias="consultorias" :operacao="operacao" :acao="acao"
                            :dataServicos="dataServicos"
                            :permiteInserirAtualizarEventos="permiteInserirAtualizarEventos"
                            :temAcessoDocumentosEvento="temAcessoDocumentosEvento" :temAcessoMetas="temAcessoMetas"
                            :permiteInserirMetas="permiteInserirMetas" :permiteCancelarMetas="permiteCancelarMetas"
                            :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
                            @atualizarEvento="atualizarEvento($event)" @atualizarErros="atualizarErros($event)"
                            @cancelarEvento="cancelarEvento($event)">
                            <template slot="botoes"> </template>
                        </consultorias-tabela>
                    </div>
                    <div v-if="temAcessoEntrega">
                        <b-row>
                            <b-col>
                                <h5 class="heading-1 mb-4">
                                    <span>Entregas</span>
                                </h5>
                            </b-col>

                        </b-row>
                        <entregas-tabela :entregas="entregas" :operacao="operacao" :acao="acao"
                            :dataServicos="dataServicos"
                            :permiteInserirAtualizarEventos="permiteInserirAtualizarEventos"
                            :temAcessoDocumentosEvento="temAcessoDocumentosEvento" :temAcessoMetas="temAcessoMetas"
                            :permiteInserirMetas="permiteInserirMetas" :permiteCancelarMetas="permiteCancelarMetas"
                            :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
                            @atualizarEvento="atualizarEvento($event)" @atualizarErros="atualizarErros($event)"
                            @cancelarEvento="cancelarEvento($event)">
                            <template slot="botoes"> </template>
                        </entregas-tabela>
                    </div>
                </div>
            </b-card-body></b-card>


    </div>
</template>

<script>
import EventosTabela from './EventosTabela'
import ConsultoriasTabela from './ConsultoriasTabela'
import BtnInserirEvento from './BtnInserirEvento'
import EntregasTabela from './EntregasTabela.vue';

export default {
    components: {
        EventosTabela,
        ConsultoriasTabela,
        EntregasTabela,
        BtnInserirEvento
    },

    props: {
        convenio: {
            type: Object,
            default: () => { }
        },
        temAcessoConsultoria: {
            type: Boolean,
            default: () => false
        },
        temAcessoEntrega: {
            type: Boolean,
            default: () => false
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        eventos: {
            type: Array,
            default: () => []
        },
        consultorias: {
            type: Array,
            default: () => []
        },
        entregas: {
            type: Array,
            default: () => []
        },

        dataServicos: {
            type: Object
        },

        permiteInserirAtualizarEventos: {
            type: Boolean,
            default: () => false
        },

        permiteCancelarEventos: {
            type: Boolean,
            default: () => false
        },

        temAcessoDocumentosEvento: {
            type: Boolean,
            default: () => false
        },

        temAcessoMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirMetas: {
            type: Boolean,
            default: () => false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirCancelarDocumentosEvento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            operacao: 'D',
            erros: [],
        }
    },

    methods: {
        cancelar() {
            this.operacao = 'D'
        },

        voltarAcao() {
            this.operacao = 'D'
            this.$emit('voltarAcao', null)
        },

        voltarEAtualizar() {
            this.$emit('atualizarAcao', null)
            this.$emit('voltarAcao', null)
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações no rateio?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarEvento()
                }
            })
        },

        salvarEvento() {
            this.$store.dispatch('addRequest')

            let eventoDto = {
                idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho,
                nomeEvento: this.evento.nomeEvento,
                codEvento: this.evento.codEvento
            }

            this.dataServicos.salvarEvento(eventoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Evento inserido com Sucesso!',
                                'OK',
                                this.$toastConfig.success)
                            this.$emit(
                                'atualizarAcao',
                                response.data)
                            this.operacao = 'D'
                        } else {
                            this.$toast.error(
                                'Falha ao inserir Evento!',
                                'ERRO',
                                this.$toastConfig.error)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
                )
        },

        atualizarEventos() {

            this.$store.dispatch('addRequest')

            this.dataServicos.obterEventosPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.eventos = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os eventos da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
        atualizarConsultorias() {

            this.$store.dispatch('addRequest')

            this.dataServicos.obterConsultoriasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.consultorias = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os consultorias da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
        atualizarEntregas() {

            this.$store.dispatch('addRequest')

            this.dataServicos.obterEntregasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.entregas = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os entregas da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        atualizarErros(eventos) {
            this.erros = eventos;
        },
    },
}
</script>
